const GadgetsWarehouseAddress = (model: IGadgetsWarehouseAddress): IGadgetsWarehouseAddressModel => {
	const { city, postcode, street, building_number, phone_number, company_name } = model

	return {
		city,
		street,
		postcode,
		buildingNumber: building_number,
		phoneNumber: phone_number,
		companyName: company_name,
	}
}

export const GadgetsWarehouse = (model: IGadgetsWarehouse): IGadgetsWarehouseModel => {
	const { id, uuid, name, address, is_external_supplier, gadget_partner_id, partner, created_at, updated_at } = model

	return {
		id,
		uuid,
		name,
		isExternalSupplier: is_external_supplier,
		gadgetPartnerId: gadget_partner_id,
		partner: partner ? GadgetsPartner(partner) : null,
		address: GadgetsWarehouseAddress(address),
		createdAt: created_at ? new Date(created_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
	}
}

/**
 * Payloads
 */
const GadgetsWarehouseAddressToPayload = (
	model: IGadgetsWarehouseDetailsAddressFormValues,
): IGadgetsWarehouseAddressPayload => {
	const { city, postcode, street, buildingNumber, phoneNumber, companyName } = model

	return {
		city,
		street,
		postcode,
		building_number: buildingNumber,
		phone_number: phoneNumber,
		company_name: companyName,
	}
}

const GadgetsWarehouseFormToSharedPayload = (
	model: IGadgetsWarehouseDetailsFormValues,
): IGadgetsWarehousePayloadShared => {
	const { name, address } = model

	return {
		name,
		gadget_partner_id: null,
		is_external_supplier: false,
		address: GadgetsWarehouseAddressToPayload(address),
	}
}

export const GadgetsWarehouseCreateToPayload = (
	model: IGadgetsWarehouseDetailsFormValues,
): IGadgetsWarehouseCreatePayload => {
	const shared = GadgetsWarehouseFormToSharedPayload(model)

	return {
		...shared,
	}
}

export const GadgetsWarehouseUpdateToPayload = (
	updated: IGadgetsWarehouseModel,
	model: IGadgetsWarehouseDetailsFormValues,
): IGadgetsWarehouseUpdatePayload => {
	const shared = GadgetsWarehouseFormToSharedPayload(model)

	return {
		id: updated.id,
		...shared,
	}
}
